export default __webpack_public_path__ + "static/media/featSportMb.2406bb34.png";